import Polyglot from 'node-polyglot';

class LocalizationManager extends Polyglot {
    declare t: (key: string, options?: Record<string, unknown>) => string;
    declare phrases: Record<string, unknown>;

    constructor(params: Record<string, unknown> = {}) {
        super(params as never);
    }

    getText(key: string, options: Record<string, unknown> | false = false) {
        if (options) {
            return this.t(key, options);
        }
        return this.t(key, { _: '%{key}', key });
    }

    getItems(key: string, options: Record<string, unknown> | false = false) {
        if (options) {
            return this.t(key, options);
        }
        return this.phrases[key] as string;
    }
}

export default LocalizationManager;
